export default __webpack_public_path__ + "static/media/windows.4f29a098.svg";